const STORAGE_KEY = "monappli:user-votes:ui";

export function getStoredVotesUi() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {
        searchTerm: "",
        viewFilter: "all",
      };
    }

    const parsed = JSON.parse(raw);

    return {
      searchTerm: parsed?.searchTerm || "",
      viewFilter: parsed?.viewFilter || "all",
    };
  } catch {
    return {
      searchTerm: "",
      viewFilter: "all",
    };
  }
}

export function saveStoredVotesUi(nextUi) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextUi));
  } catch {
    // localStorage indisponible.
  }
}

export function formatVoteDate(value) {
  if (!value) return "—";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "—";

  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  };

  return date.toLocaleDateString("fr-FR", options).replace(",", " -");
}

export function formatBallotDate(value) {
  if (!value) return "—";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function getVoteTypeLabel(type) {
  const normalized = String(type || "vote").toLowerCase();

  if (normalized === "sondage") return "Sondage";
  return "Vote";
}

export function getVoteTypeClass(type) {
  const normalized = String(type || "").toLowerCase();

  if (normalized === "sondage") {
    return "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-200";
  }

  return "bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200";
}

export function getVoteStatusInfo(vote) {
  const now = new Date();
  const start = vote?.start_time ? new Date(vote.start_time) : null;
  const end = vote?.end_time ? new Date(vote.end_time) : null;

  if (start && now < start) {
    return {
      key: "scheduled",
      label: "Programmé",
      className:
        "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200",
    };
  }

  if (end && now > end) {
    return {
      key: "closed",
      label: "Clôturé",
      className:
        "bg-slate-200 text-slate-800 dark:bg-slate-800/60 dark:text-slate-200",
    };
  }

  if (vote?.is_active) {
    return {
      key: "active",
      label: "Actif",
      className:
        "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200",
    };
  }

  return {
    key: "inactive",
    label: "Inactif",
    className:
      "bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-200",
  };
}

export function isVoteVisibleToUser(vote) {
  if (!vote?.is_active) return false;

  const now = new Date();

  const start = vote?.start_time ? new Date(vote.start_time) : null;
  const end = vote?.end_time ? new Date(vote.end_time) : null;

  const startLimit = start ? new Date(start) : null;
  const endLimit = end ? new Date(end) : null;

  if (startLimit) {
    startLimit.setDate(startLimit.getDate() - 1);
  }

  if (endLimit) {
    endLimit.setDate(endLimit.getDate() + 1);
  }

  if (startLimit && now < startLimit) return false;
  if (endLimit && now > endLimit) return false;

  return true;
}

export function filterVotesBySearch(votes = [], searchTerm = "") {
  const query = searchTerm.trim().toLowerCase();

  if (!query) return votes;

  return votes.filter((vote) =>
    `${vote?.title || ""} ${vote?.description || ""} ${vote?.type || ""}`
      .toLowerCase()
      .includes(query)
  );
}

export function getBallotTimestamp(ballot) {
  return ballot?.timestamp || ballot?.created_at || ballot?.updated_at || null;
}